<!-- 定时签到设置结果展示板 -->
<template>
  <section class="timer-sign-board">
    <p class="title">{{ $t('host.k_592001') }}</p>
    <p class="description">{{ $t('host.k_592002', [formatMergedTimes(notPushedTimes)]) }}</p>
    <p class="warn-tip">{{ $t('host.k_592008') }}</p>

    <vh-button class="btn-view-record" type="text" size="medium" round @click="$emit('viewList')">
      {{ $t('host.k_595075') }}
    </vh-button>
    <vh-button
      class="btn-create-sign"
      type="primary"
      size="small"
      round
      @click="$emit('toSignCreate')"
    >
      {{ $t('host.k_595076') }}
    </vh-button>
  </section>
</template>
<script>
  export default {
    name: 'TimerSignBoard',
    props: {
      // 到还未推送的时间集合
      notPushedTimes: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      formatMergedTimes(timeArray) {
        const grouped = {};
        // 1. 先按日期分组
        timeArray.forEach(timeStr => {
          const [date, time] = timeStr.split(' ');
          if (!grouped[date]) {
            grouped[date] = [];
          }
          grouped[date].push(time);
        });
        // 2. 格式化为目标字符串
        const result = [];
        Object.keys(grouped)
          .sort()
          .forEach(date => {
            const times = grouped[date];
            const formatted = `${date} ${times.join('、')}`;
            result.push(formatted);
          });

        return result.join(', ');
      }
    }
  };
</script>
<style lang="less" scoped>
  .timer-sign-board {
    position: relative;
    width: calc(100% - 60px);
    height: 440px;
    left: 30px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    padding: 0 12px;
    box-sizing: border-box;

    .title {
      padding-top: 170px;
      margin-bottom: 20px;
      font-weight: 500;
      text-align: center;
    }
    .description {
      height: 60px;
      overflow: auto;
    }

    .warn-tip {
      color: #fb2626;
      margin-top: 20px;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .btn-view-record {
      position: absolute;
      bottom: 20px;
    }
    .btn-create-sign {
      position: absolute;
      bottom: 14px;
      right: 0;
    }
  }
</style>
